import React from 'react'
import Header from '../../components/header/Header'
import PageHeading from '../../components/pageHeading/PageHeading'
import Footer from '../../components/footer/Footer'
import './contactUs.scss'
import { CheckMarkIcon } from '../../components/Icons'
import AboutImg1 from '../../assets/images/about-1.jpg'
import AboutImg2 from '../../assets/images/about-2.jpg'
import { Button } from 'react-bootstrap'
import SelectDateTime from '../../customer/selectDateTime/SelectDateTime'
import { useEffect, useState } from 'react'
import { getContent, getAllContent } from '../../services/auth.service'
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from '../../slice/commonSlice'

const ContactUs = () => {
    const [contentId,setContentId]=useState();
    const [content,setContent]=useState();
    const dispatch = useDispatch();

    const getallcontent = async () => {
        try{
            await dispatch(setLoader(true));
            const result = await getAllContent();
            if (result?.status === 200) {
            const searchObject = result.data.find((data) => data.slug == "contactUs");            
                setContentId(searchObject._id)
                await dispatch(setLoader(false));
            }else{
                await dispatch(setLoader(false));
            }
           
        }catch(e){
            await dispatch(setLoader(false));
            console.log(e)
        }
       
    }

    const getcontent = async () => {
        // const paylaod = { "_id": contentId }
        // const result = await getContent(paylaod);
        // console.log(result,"all ther result")
        // setContent(result.data.content)

        // return
        try{
        await dispatch(setLoader(true));
        const paylaod = { "_id": contentId }
        const result = await getContent(paylaod);
        if (result?.status === 200) {
            setContent(result.data.content)
            await dispatch(setLoader(false));
          } else {
            await dispatch(setLoader(false));
          }
        } catch (e) {
          await dispatch(setLoader(false));
        console.log("error", e);

        }       
    }

    useEffect(() => {
        getallcontent()
    }, [])

    useEffect(() => {
        getcontent()
    }, [contentId])

    return (
        <>
            <Header />
            <PageHeading title="Contact us" />
            <div className='main-container'>
                <div className='container-wrap'>
                    <div className='about-container-wrap'>
                        {/* <div className='about-content-wrap'>
                            <div className='about-content order-lg-0 order-1'>
                                <h4>Our Mission</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here'.</p>
                                <ul>
                                    <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted.</li>
                                    <li><i><CheckMarkIcon /></i> The standard chunk of Lorem Ipsum used.</li>
                                    <li><i><CheckMarkIcon /></i> There are many variations of passages of Lorem Ipsum available.</li>
                                </ul>
                                <Button variant='primary'>Contact us</Button>
                            </div>
                            <div className='about-img-wrap order-lg-1 order-0'><img src={AboutImg1} alt='About' /></div>
                        </div>
                        <div className='about-content-wrap'>
                            <div className='about-img-wrap'><img src={AboutImg2} alt='About' /></div>
                            <div className='about-content'>
                                <h4>Our Vission</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here'.</p>
                                <ul>
                                    <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted.</li>
                                    <li><i><CheckMarkIcon /></i> The standard chunk of Lorem Ipsum used.</li>
                                    <li><i><CheckMarkIcon /></i> There are many variations of passages of Lorem Ipsum available.</li>
                                </ul>
                                <Button variant='primary'>Contact us</Button>
                            </div>

                        </div> */}
                         <div dangerouslySetInnerHTML={{ __html: "Please reach out to info@helpr.bm if you require any assistance." }} />
                    </div>
                </div>
            </div>
            <Footer />
            {/* <SelectDateTime/> */}
        </>
    )
}

export default ContactUs